import InfoTooltip from "components/Popup/InfoTooltip";
import { IConsumableExemptionFinancials } from "Dashboard/scenes/Projects/domain/IConsumableExemptionFinancials";
import ResourcesSelect from "Dashboard/scenes/Resources/components/ResourcesSelect";
import { unitNameLabel } from "Dashboard/scenes/Resources/helpers/resourceUtil";
import { FormatDateShort } from "utils/dateUtils";
import { FormatNumberOrNull, FormatNumberWithUnitOrNull } from "utils/numberUtils";
import { styles } from "./SelectStatisticsStyle";
import { useAppDispatch } from "hooks/hooks";
import { getProjectConsumableFinancials, selectState } from "../financials.slice";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

interface IProps {
  data: IConsumableExemptionFinancials | undefined;
  projectId: number;
}

const FuelAndResources = ({ data, projectId }: IProps) => {
  const dispatch = useAppDispatch();
  const { selectedDateFrom, selectedDateTo } = useSelector(selectState);
  const [resourceId, setResourceId] = useState();

  useEffect(() => {
    if (projectId) {
      setResourceId(undefined);
    }
  }, [projectId]);

  useEffect(() => {
    const abortCtrl = new AbortController();
    if (projectId) {
      dispatch(getProjectConsumableFinancials({
        data: {
          projectId,
          from: selectedDateFrom,
          to: selectedDateTo,
          resourceId
        },
        signal: abortCtrl.signal
      }));
    }
    return () => {
      if (projectId) {
        abortCtrl.abort();
      }
    };
  }, [
    dispatch,
    projectId,
    selectedDateFrom,
    selectedDateTo,
    resourceId
  ]);

  return (
    <div>
      <h3>
        <strong>GORIVO</strong> po zaduženju i <strong>Resursi</strong>
      </h3>
      <section>
        <div className="projects-box-header">
          <div>
            <span className="right-align flexBasis90">gorivo suma</span>
            <span className="strong-txt center-align txt-underline">
              {FormatNumberWithUnitOrNull(data?.fuelQuantity, 'l')}
            </span>
            <span className="strong-txt center-align txt-underline">
              {FormatNumberWithUnitOrNull(data?.totalFuelEstimatedCost, 'rsd')}
            </span>
          </div>
          <div>
            <span className="right-align flexBasis90">suma km/sati</span>
            <span className="strong-txt center-align txt-underline">
              {FormatNumberWithUnitOrNull(data?.totalKilometersCharged, 'km')}
            </span>
            <span className="strong-txt center-align txt-underline">
              {FormatNumberWithUnitOrNull(data?.totalHoursCharged, 'sati')}
            </span>
          </div>
          <div>
            <span className="right-align flexBasis90">suma najam</span>
            <span className="strong-txt center-align txt-underline flexBasis200">
              {FormatNumberWithUnitOrNull(data?.totalLeaseCost, 'rsd')}
            </span>
          </div>
        </div>
        <div>
          <ResourcesSelect
            key={projectId}
            customStyles={styles.customStyleClassic}
            onChange={setResourceId}
          />
        </div>
        <div className="projects-box-content">
          <div className="list-wrapp">
            {data?.consumableExemptionEntries &&
              data.consumableExemptionEntries.map((entry, index) => (
                <article key={index}>
                  <div className="col-1">
                    <span className="box-span left strong">
                      {entry.vehiclesModelAndType}
                    </span>
                  </div>
                  <div>
                    <span className="box-span grid-span-2">
                      {entry.employeeName}
                    </span>
                    <span className="box-span">
                      {FormatDateShort(entry.dateCharge)}
                    </span>
                  </div>
                  <div>
                    {entry.usageUnit !== undefined
                      ? (<InfoTooltip tooltip={unitNameLabel(entry.usageUnit)} classesProp="box-span right" element="span">
                        {FormatNumberWithUnitOrNull(entry.distanceAmount, entry.usageUnit?.name)}
                      </InfoTooltip>)
                      : (<span className="box-span"></span>)}
                    <InfoTooltip tooltip="najam" classesProp="box-span right" element="span">
                      {FormatNumberWithUnitOrNull(entry.leaseCost, 'rsd')}
                    </InfoTooltip>
                    {entry.dateDischarge !== undefined && entry.dateDischarge !== null && (
                      <span className="box-span">
                        {FormatDateShort(entry.dateDischarge)}
                      </span>
                    )}
                  </div>
                  <div>
                    <InfoTooltip
                      tooltip={entry.averageFuelConsumption !== undefined && entry.averageFuelConsumption !== null ? 'pros. potrošnja' : 'potrošeno goriva'}
                      classesProp="box-span right" element="span">
                      {entry.averageFuelConsumption !== undefined && entry.averageFuelConsumption !== null
                        ? FormatNumberOrNull(entry.averageFuelConsumption)
                        : FormatNumberWithUnitOrNull(entry.exactFuelConsumed, 'l')}
                    </InfoTooltip>
                    <span className="light-color">
                      {entry.averageFuelConsumption !== undefined && entry.averageFuelConsumption !== null ? 'pros. potrošnja' : 'potrošeno goriva'}
                    </span>
                    <InfoTooltip element="span"
                      tooltip={entry.note}
                      classesProp="light-color bg-text-overflow">
                      {entry.note}
                    </InfoTooltip>
                  </div>
                </article>
              ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default FuelAndResources;
